import uuidv4 from 'uuid/v4';
import {
    SINGLE_CHAT_MESSAGE_HISTORY,
    SINGLE_CHAT_MEDIA,
    SINGLE_CHAT_MEDIA_RESET,
    SINGLE_CHAT_MEDIA_UPDATE,
    SINGLE_CHAT_SELECTED_MEDIA,
    SINGLE_CHAT_SELECTED_MEDIA_RESET,
    SINGLE_CHAT_MESSAGE_RESET,
    SINGLE_CHAT_MESSAGE_REMOVE,
    SINGLE_CHAT_MESSAGE_RECALL,
    CHAT_SEEN_PENDING_MSG,
    DELETE_CHAT_SEEN_PENDING_MSG,
    CHAT_SEEN_PENDING_MSG_BULK,
} from '../Actions/Constants';
import { updateRecall } from '../Helpers/Chat/Recall';
import { concatMedia, concatMessageArray } from '../Helpers/Chat/ChatHelper';
import { GROUP_UPDATE_ACTIONS } from '../Helpers/Chat/Constant';
import { getUserIdFromJid } from '../Helpers/Utility';

const initialState = {
    id: null,
    data: [],
};

const removeMessage = (newMesssage, existingArray) => {
    return existingArray.filter(message => {
        const { broadcast_msgid, msgId } = message;
        let updateMessageId = broadcast_msgid || msgId;
        return newMesssage.indexOf(updateMessageId) === -1;
    });
};

export function SingleChatMessageReducer(state = initialState, action = {}) {
    const { id, data } = action.payload || {};
    switch (action.type) {
        case SINGLE_CHAT_MESSAGE_HISTORY:
            return {
                ...state,
                ...{
                    id: id,
                    data: data.length > 0 ? concatMessageArray(data, state.data, 'msgId', 'timestamp') : [],
                },
            };
        case SINGLE_CHAT_MESSAGE_RECALL:
            return {
                ...state,
                id,
                data: updateRecall(data, state.data),
            };
        case SINGLE_CHAT_MESSAGE_REMOVE:
            return {
                ...state,
                ...{
                    id: id,
                    data: removeMessage(data, state.data),
                },
            };
        case SINGLE_CHAT_MESSAGE_RESET:
            return {
                id,
                data: [],
            };
        default:
            return state;
    }
}

export function SingleChatMediaReducer(state = initialState, action) {
    const { id, data } = action.payload || {};
    switch (action.type) {
        case SINGLE_CHAT_MEDIA:
            return {
                ...state,
                ...{
                    id: id,
                    data: concatMedia(data, state.data),
                },
            };
        case SINGLE_CHAT_MEDIA_UPDATE:
            return {
                id: id,
                data: data,
            };
        case SINGLE_CHAT_MEDIA_RESET:
            return {
                id: null,
                data: [],
            };
        default:
            return state;
    }
}

export function SingleChatSelectedMediaReducer(state = [], action) {
    switch (action.type) {
        case SINGLE_CHAT_SELECTED_MEDIA:
            return action.payload;
        case SINGLE_CHAT_SELECTED_MEDIA_RESET:
            return {
                id: null,
                data: [],
            };
        default:
            return state;
    }
}

const storyPreviewInitialState = {
    id: null,
    data: {
        StoryMediaData: [],
    },
};

const normalizeStoryDataByUser = (storyMediaData = []) => {
    if (!Array.isArray(storyMediaData)) return [];
    const mergedByUser = {};
    storyMediaData.forEach(group => {
        if (!group || typeof group !== 'object') return;
        const userId = Object.keys(group)[0];
        if (!userId) return;
        const stories = Array.isArray(group[userId]) ? group[userId] : [];
        const existing = mergedByUser[userId] || [];
        const mapByStoryId = {};
        [...existing, ...stories].forEach(story => {
            if (!story) return;
            const key = story.storyId || story.msgId || story.id;
            if (key) mapByStoryId[key] = story;
        });
        mergedByUser[userId] = Object.values(mapByStoryId).sort((a, b) => (a.timestamp > b.timestamp ? -1 : 1));
    });
    return Object.keys(mergedByUser).map(userId => ({ [userId]: mergedByUser[userId] }));
};

export const chatSeenPendingMsgReducer = (state = { id: uuidv4(), data: {} }, action = {}) => {
    let { id, data } = state;
    switch (action.type) {
        case CHAT_SEEN_PENDING_MSG: {
            const messageObj = action?.payload?.messageObj;
            if (!messageObj) return state;

            const isGroupProfileUpdate = GROUP_UPDATE_ACTIONS.includes(messageObj.profileUpdatedStatus);
            const userId = isGroupProfileUpdate ? getUserIdFromJid(messageObj.userJid) : messageObj.fromUserId;
            const compositeKey = `${userId}_${messageObj.msgId}`;

            return {
                id: uuidv4(),
                data: {
                    ...state.data,
                    [compositeKey]: messageObj,
                },
            };
        }

        case CHAT_SEEN_PENDING_MSG_BULK: {
            const messages = action?.payload?.messages;
            if (!messages || !Array.isArray(messages) || messages.length === 0) return state;

            const newData = { ...state.data };
            messages.forEach(messageObj => {
                const isGroupProfileUpdate = GROUP_UPDATE_ACTIONS.includes(messageObj.profileUpdatedStatus);
                const userId = isGroupProfileUpdate ? getUserIdFromJid(messageObj.userJid) : messageObj.fromUserId;
                const compositeKey = `${userId}_${messageObj.msgId}`;
                newData[compositeKey] = messageObj;
            });

            return {
                id: uuidv4(),
                data: newData,
            };
        }

        case DELETE_CHAT_SEEN_PENDING_MSG: {
            const { messageId } = action.payload;
            const keyToDelete = Object.keys(state.data).find(key => key.endsWith(`_${messageId}`));

            if (!keyToDelete) return state;

            const { [keyToDelete]: _, ...rest } = state.data;
            return { id: uuidv4(), data: rest };
        }

        default:
            return state;
    }
};
